import { useState } from 'react';

export function useSegmentCounter(currentSegments: number) {
  const [prevSegments, setPrevSegments] = useState(currentSegments);
  const segmentDiff = currentSegments - prevSegments;

  const handleAnimationComplete = () => {
    setPrevSegments(currentSegments);
  };

  return {
    segmentDiff,
    onAnimationComplete: handleAnimationComplete
  };
}
